import { render, staticRenderFns } from "./CityAddress.vue?vue&type=template&id=571163c0"
import script from "./CityAddress.vue?vue&type=script&lang=js"
export * from "./CityAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports